import React from 'react'
import {AttentionSummary, AttentionSummaryProps} from './AttentionSummary'
import {Nullable} from '../../../../../Common/TypeHelper'

type TakeoverAttentionSummaryProps = Pick<AttentionSummaryProps, 'display'> & {
  bucketMemberId: Nullable<string>
}
export const TakeoverAttentionSummary: React.VFC<TakeoverAttentionSummaryProps> = (
  {
    display,
    bucketMemberId,
  },
) => {
  return (
    <AttentionSummary
      display={display}
      headline={'以前の会員番号と継続期間が引き継がれます。'}
      details={getDetails(bucketMemberId)}
      testId={'takeover-attention-summary-card'}
    />
  )
}

const getDetails = (bucketMemberId: Nullable<string>): string[] => {
  const details = ['退会した同月内に再入会(お支払い含む)のお手続きを完了することで、引き継ぎ入会することができます。']

  if (!bucketMemberId) {
    return details
  }

  details.push(`・引き継ぐ会員番号：${bucketMemberId}`)
  return details
}
